import { products, type Product } from "../data/products";
import ProductCard from "../components/ProductCard";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import { productsCategoryData } from "data/category";
import CategorySEO from "components/CategorySEO";

export default function Products() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Produits" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title={productsCategoryData.title}
        description={productsCategoryData.description}
        canonicalPath={productsCategoryData.canonicalPath}
      />
      <CategorySEO products={products} />
      <h1>Produits</h1>
      <div className="grid" style={{ marginTop: 12 }}>
        {products.map((product: Product) => (
          <ProductCard key={product.sku} productSpecific={product} />
        ))}
      </div>
    </>
  );
}
